import { createContext } from "react";

export const THEMES = {
    black: "black",
    red: "red",
    white: "white"
};

export const AppContext = createContext({
    theme: THEMES.white,
    changeTheme: () => {},
    browserInfo: {}
});



// WEBPACK FOOTER //
// ./src/scripts/context/app.js